import { faTv } from "@fortawesome/pro-duotone-svg-icons";
import { faChevronRight } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Mensagem as Conversa } from "../../../interfaces/entities/SaudeBemEstar/ChatComEquipeGC/Mensagem";
import { sxGreenTextButton } from "../../../pages/GestaoDeCronicos/ChatComEquipePersonal/ConversasPersonal/sxProps";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";
import DefaultText from "../../Accessibility/DefaultText";
import DefaultTextBold from "../../Accessibility/DefaultTextBold";
import WhiteContainer from "../../Accessibility/WhiteContainer";
import { ChatTypeEnum } from "../ChatTypeEnum";
import './styles.css';
import { truncateText } from "../../../utils/TextUtils";

const ChatCard: React.FC<{ conversa: Conversa, chatType: ChatTypeEnum }> = ({ conversa, chatType }) => {

  const acessibility = useAccessibility();
  const navigate = useNavigate();

  const isFinalized = chatType === ChatTypeEnum.GC ? (conversa.status === 'CONCLUÍDA') : (conversa.status === 'MF');
  const chatContext = chatType === ChatTypeEnum.GC ? '/saudeBemEstar/gestaoDeCronicos/conversaEquipe' : '/saudeOnline/faleComPersonal/conversaEquipe';

  return (
    <WhiteContainer 
      className="chat-card cursor-pointer" 
      shadow
      onClick={() => navigate(`${chatContext}/conversas/${conversa.idMensagem}/chat`)}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          navigate(`${chatContext}/conversas/${conversa.idMensagem}/chat`);
        }
      }}
      tabIndex={0} 
    >
      <div id='card-icon-holder'>
        <FontAwesomeIcon icon={faTv} className={isFinalized ? 'fa-icon32x32-disabled' : 'fa-icon32x32'}
          style={acessibility.textStyleAccessibility} />
      </div>
      <div className="card-infos-holder">
        {conversa.mensagem && <DefaultTextBold text={truncateText(conversa.mensagem, 60)} className={isFinalized ? 'dashed-text' : ''} />}
        {chatType === ChatTypeEnum.GC &&
          <div className="info-frame">
            <DefaultText className='bold-label' text={'<b>Protocolo:</b>&nbsp;GC - ' + conversa.idMensagem} />
          </div>
        }
        <div className="info-frame">
          <DefaultText className='bold-label' text={'<b>Data do atendimento:</b>&nbsp;' + conversa.dtMensagem} />
        </div>
        {!isFinalized &&
          <Typography 
            sx={sxGreenTextButton} 
            style={acessibility.textStyleAccessibility}
            aria-label={`ver conversa de ${conversa.dtMensagem}, sobre ${conversa.mensagem}`}
          >
            <u>ver conversa</u>&nbsp;<FontAwesomeIcon icon={faChevronRight} />
          </Typography>
        }
      </div>
    </WhiteContainer>
  )
}

export default ChatCard;